module.exports = __webpack_public_path__ + "img/banner.0f86a07d.png";